import { JsonObject, JsonProperty } from 'json2typescript';
import Thumbnail from '@/models/exam/Thumbnail';

@JsonObject('benefits_resources')
export default class BenefitsResource {
  constructor() {
    this.benefitsType = undefined;
  }

  @JsonProperty('benefits_type')
  public benefitsType?: string;

  @JsonProperty('thumbnail')
  public thumbnail?: Array<Thumbnail> = [];

  @JsonProperty('order')
  public order?: string;

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('explanation')
  public explanation?: string;

  @JsonProperty('notes')
  public notes?: string;
}
